import 'babel-polyfill'
import Vue from 'vue'
import Vuex from 'vuex'
import {setToken,removeToken} from '@/utils/auth'
import {login} from '@/api/admin/login.js'
import tab from './modules/tab.js'

import 'babel-polyfill'
Vue.use(Vuex)

let admin =  new Vuex.Store({
   state:{
    accessToken:""
   },
   mutations:{
    SET_ACCESSTOKEN:(state,accessToken)=>{
      state.accessToken = accessToken
    },
    INIT_TAB:(state)=>{
      console.log(state.tab)
      state.tab.openTab=[]
      state.tab.activeTab=""
    }
   },
   actions:{
 //登录
 Login({commit},userInfo){
  const username = userInfo.username.trim()
  return new Promise((resolve, reject)=>{
    login(username,userInfo.password).then(response=>{
      // console.log(response)
      if(response && response.code==200){
        setToken(response.Authorization)//保存到本地
        commit('SET_ACCESSTOKEN',response.Authorization)//保存到state中
        resolve()
      } else {
        reject(response || {message:'登录失败'})
      }
    }).catch(err=>{
      reject(err)
    })
  })
},
    //登出
    Logout({commit}){
      return new Promise((resolve)=>{
          commit('SET_ACCESSTOKEN','')
          commit('INIT_TAB')
          removeToken()
          resolve()
      })
    },
   },
   modules:{
     tab
   }
})

export default admin